import { render } from "./Apartment.vue?vue&type=template&id=485cb1b4"
import script from "./Apartment.vue?vue&type=script&lang=js"
export * from "./Apartment.vue?vue&type=script&lang=js"

import "./Apartment.vue?vue&type=style&index=0&id=485cb1b4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__